
import { useTranslation as useI18nTranslation } from 'react-i18next';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };
  
  const getCurrentLanguage = () => i18n.language;
  
  const getAvailableLanguages = () => ['en', 'es'];
  
  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
  };
};
